import SelectOption from './SelectOptions';
import RemoteArea from './RemoteArea';
import DeliveryCompany from './DeliveryCompany';
import Payment from './Payment';
import PlaceHolder from './PlaceHolder';
import PaymentStatus from './PaymentStatusConstants';
// import InquirySubType from './InquirySubType';

const CONSTANTS = {
  ...SelectOption,
  REMOTE_AREA: RemoteArea,
  DELIVERY_COMPANY: DeliveryCompany,
  ...Payment,
  PLACE_HOLDER: PlaceHolder,
  ...PaymentStatus,
  // INQUIRY_SUB_TYPE: InquirySubType,
  BUSINESS_CATEGORY_NAME: '사업자 회원 전용',
};

// export { default as InquirySubType } from './InquirySubType';
export default CONSTANTS;
